import { gql } from '@apollo/client/core'

export const VariantTile = gql`
fragment VariantFormTile on Variant {
  id
  _id
  title
  price
  priceSpecial
  sku
  position
  isCrop
  thumbnail
  thumbnailWebp
  isRounded
  isPublished
  isFormula
  isDefault
  isFeatured
  formula
  size {
    id
    title
      cmWidth
      cmHeight
      pxWidth
      pxHeight
      shape
      cornerRadiusMm
      bleedMm
      safeMarginMm
      dpiTarget
      shapeParams
  }
  variantGroup{
    id
  }

}`


export const ProductFormTile = gql`
  fragment ProductFormTile on Product {
    id
    _id
    description
    page{
      id
      title
    }
    price
    hasIndividualSizes
    isCalculated
    title
    shippingInfo
    shippingDuration
    titleShort
    editorOverrideConfig
    thumbnail
    thumbnailWebp
    owner{
      id
      firstname
      lastname
    }
    minSizeX
    minSizeY
    maxSizeX
    maxSizeY
    formula
    stock
    sku

    isPublished
    isDeleted
    categories{
    edges{
      node{
          _id
          editorType
          id
        title
      }
    }
  }
    variantGroupTexts(first: 50){
      edges{
        node{
          id
         description
          variantGroup{
            id
          }
        }
      }
    }

    variantGroups(first: 50){
      edges{
        node{
          id
          title
          isSize
          showInTile

          icon
        }
      }
    }
   
    variants(first: 300){
      edges{
        node{
          ...VariantFormTile
        }
      }
    }

  }
${VariantTile}`;

export const getVariantGroupTextByProduct = gql`
  query getVariantGroupTextByProduct($productId: String) {
    variantGroupTexts(product: $productId) {
      edges {
        node {
          id
          _id
          description
          variantGroup{
            id
            title
          }
        }
      }
    }
  }

`

export const getVariantsByProduct = gql`
  query getVariantsByProduct($productId: String) {
    variants(product: $productId, first: 200) {
      edges {
        node {
          ...VariantFormTile
        }
      }
    }
  }
  ${VariantTile}
`
export const  ProductListTile = gql`
  fragment ProductListTile on Product {
    _id
    id
    title
    titleShort
    description
    price
    isCalculated
    sku
    isPublished
    shortDescription
      thumbnail
      thumbnailWebp
    isDeleted
    owner{
      id
      firstname
      lastname
    }
    categories{
      edges{
        node{
          thumbnail
          thumbnailWebp
          _id
          id
          title
          showInEditor
          editorType
          parent {
            _id
            id
            title
            thumbnail
            thumbnailWebp
            editorType
          }
        }
      }
    }
    variants{
      totalCount
    }
  }
`;

export const CategoryTile = gql`
  fragment CategoryListTile on Category {
    id
    _id
    title
    productCount
    description
    showInEditor
    thumbnail
    editorConfig
    editorType
    thumbnailWebp
    parent {
      _id
      id
      title
      thumbnail
      thumbnailWebp
      editorType
    }
  }
`;

export const getCategories = gql`
  query getCategories($pageSize: Int!, $after: String, $parent: String, $search: String, $exists: [CategoryFilter_exists], $order: [CategoryFilter_order], $isPublished: Boolean, $isDeleted: Boolean, $showInEditor: Boolean) {
    categories(first: $pageSize, after: $after, search: $search, parent: $parent, exists: $exists, order: $order, isPublished: $isPublished, isDeleted: $isDeleted, showInEditor: $showInEditor) {
      pageInfo{
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
      totalCount
      edges{
        node{
          ...CategoryListTile
        }
      }
    }
  }${CategoryTile}`;
export const getProducts = gql`
  query getProducts($pageSize: Int!, $after: String, $category: String, $search: String, $isPublished: Boolean,  $isDeleted: Boolean, $order: [ProductFilter_order]) {
    products(first: $pageSize, after: $after, search: $search, categories: $category,  isPublished: $isPublished, isDeleted: $isDeleted,  order: $order) {
      pageInfo{
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
      totalCount
      edges{
        node{
          ...ProductListTile
        }
      }
    }
  }${ProductListTile}`;
export const getProduct = gql`
    query getProduct($id: ID!) {
        product(id: $id) {
            ...ProductFormTile
        }

    }
    ${ProductFormTile}`;
export const getCategory = gql`
  query getCategory($id: ID!) {
    category(id: $id) {
      ...CategoryListTile
    }

  }
${CategoryTile}`;


export const VoucherFormTile = gql`
  fragment VoucherFormTile on Voucher {
    id
    _id
   minPrice
    used
    usage
    startAt
    endAt
    code
    discount
    discountPrice
    owner{
      id
      firstname
      lastname
    }
    isOnAllProducts
    isFreePostage
    externalIds
    isPublished
    products{
      edges{
        node{
          id
          title
        }
      }
    }

  }
`;
export const VoucherListTile = gql`
  fragment VoucherListTile on Voucher {
    id
    _id
    minPrice
    used
    usage
    startAt
    endAt
    code
    discount
    discountPrice
    owner{
      id
      firstname
      lastname
    }
    isOnAllProducts
    isFreePostage
    externalIds
    isPublished
    products{
      edges{
        node{
          id
          title
        }
      }
    }

  }
`;
export const getVouchers = gql`
  query getVouchers($pageSize: Int!, $after: String, $search: String,  $isPublished: Boolean, $order: [VoucherFilter_order]) {
    vouchers(first: $pageSize, after: $after, search: $search,   isPublished: $isPublished,  order: $order) {
      pageInfo{
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
      totalCount
      edges{
        node{
          ...VoucherListTile
        }
      }
    }
  }${VoucherListTile}`;
export const getVoucher = gql`
  query getVoucher($id: ID!) {
    product(id: $id) {
      ...VoucherFormTile
    }

  }
${VoucherFormTile}`;
